import Header from "../../components/Header/Header";
import iconReceipt from "../../assets/icon_refund_receipt.svg";
import iconStore from "../../assets/icon_refund_store.svg";
import iconCard from "../../assets/icon_refund_card.svg";
import iconSale from "../../assets/icon_refund_sale.svg";
import iconTit1 from "../../assets/icon_refund_tit1.svg";
import iconTit2 from "../../assets/icon_refund_tit2.svg";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useSelectBrandId from "#src/features/Refund/hooks/useSelectBrand.js";


const nbRefundGuidelines = [
  {
    icon: iconReceipt,
    guidelines: [
      {
        mainText: "영수증 지참 시에만 교환/환불이 가능 합니다.",
        subText:
          "미지참 시, 1개월 이내 노브랜드에서의 구입 정보가 없으면 교환/환불이 불가합니다.",
      },
      {
        mainText:
          "판매 가능한 정상상품에 한해 구입가격으로 환불해 드립니다. (패키지 개봉/파손, 의류 수선 시 불가)",
        subText: "증정품/경품이 있는 경우 반납 후 가능합니다.",
      },
    ],
  },
  {
    icon: iconStore,
    guidelines: [
      {
        mainText: "구입점포에서 교환 가능합니다.",
        subText: "현금영수증 취소관련 규정에 준함 : 국세청고시 제20129호 제2조",
      },
      {
        mainText:
          "노브랜드에서 구입한 모든 상품은 구매한 점포에서만 교환/환불이 가능합니다. (타점환불 불가)",
      },
      {
        mainText:
          "노브랜드에서 구입한 상품은 이마트에서 교환/환불이 불가능 합니다.",
      },
    ],
  },
  {
    icon: iconCard,
    guidelines: [
      {
        mainText:
          "카드사용 거래 취소 시, 결제한 카드를 지참해야만 할 수 있습니다.",
        subText:
          "결제수단 변경 또는 일부 상품에 대한 환불 요청 시, 결제했던 카드(현금 결제 제외)와 재결제 수단을 하셔야 합니다. (취소 후 재결제)",
      },
      {
        mainText: "상품별 부분취소는 불가하며 전체 취소 후 재결제 진행됩니다.",
      },
    ],
  },
  {
    icon: iconSale,
    guidelines: [
      {
        mainText:
          "쿠폰, 할인권 등은 각 쿠폰에 명시된 규정에 준하여 처리합니다.",
      },
      {
        mainText:
          "모바일 금액권 환불시 결제한 동일한 모바일 쿠폰으로 환불됩니다. (이마티콘, 기프티콘, 모바일 금액권 등)",
        subText:
          "구매 후 모바일 쿠폰 삭제하였을 경우에는 해당 발행사에 문의 바랍니다.",
      },
    ],
  },
];

const edRefundGuidelines = [
  {
    icon: iconReceipt,
    guidelines: [
      {
        mainText: "영수증 지참 시에만 교환/환불이 가능 합니다.",
        subText:
          "미지참 시, 1개월 이내 에브리데이에서의 구입 정보가 없으면 교환/환불이 불가합니다.",
      },
      {
        mainText:
          "구입 후 30일 이내 (신선식품 및 냉장/냉동 식품은 7일 이내)",
      },
      {
        mainText:
          "판매 가능한 정상상품에 한해 구입가격으로 환불해 드립니다. (패키지 개봉/파손, 의류 수선 시 불가)",
        subText: "증정품/경품이 있는 경우 반납 후 가능합니다.",
      },
    ],
  },
  {
    icon: iconStore,
    guidelines: [
      {
        mainText: "구입점포에서 교환 가능합니다.",
        subText: "현금영수증 취소관련 규정에 준함 : 국세청고시 제20129호 제2조",
      },
      {
        mainText:
          "에브리데이에서 구입한 모든 상품은 구매한 점포에서만 교환/환불이 가능합니다. (타점환불 불가)",
      },
      {
        mainText:
          "에브리데이에서 구입한 상품은 이마트에서 교환/환불이 불가능 합니다.",
      },
    ],
  },
  {
    icon: iconCard,
    guidelines: [
      {
        mainText:
          "카드사용 거래 취소 시, 결제한 카드를 지참해야만 할 수 있습니다.",
        subText:
          "결제수단 변경 또는 일부 상품에 대한 환불 요청 시, 결제했던 카드(현금 결제 제외)와 재결제 수단을 하셔야 합니다. (취소 후 재결제)",
      },
      {
        mainText: "상품별 부분취소는 불가하며 전체 취소 후 재결제 진행됩니다.",
      },
    ],
  },
  {
    icon: iconSale,
    guidelines: [
      {
        mainText:
          "쿠폰, 할인권 등은 각 쿠폰에 명시된 규정에 준하여 처리합니다.",
      },
      {
        mainText:
          "모바일 금액권 환불시 결제한 동일한 모바일 쿠폰으로 환불됩니다. (이마티콘, 기프티콘, 모바일 금액권 등)",
        subText:
          "구매 후 모바일 쿠폰 삭제하였을 경우에는 해당 발행사에 문의 바랍니다.",
      },
    ],
  },
];

export const TableRow = ({ category, items }) => {
  return (
    <tr>
      <th className="p-3 font-medium align-top border-b border-r border-neutral-200">
        {category}
      </th>
      <td className="p-3 border-b border-neutral-200">
        <ul>
          {items.map((item, index) => (
            <li
              key={index}
              className="flex gap-1.5 text-neutral-500 before:content-['*'] font-medium"
            >
              {item}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  );
};

export const InfoCard = ({ icon, guidelines }) => {
  return (
    <li className="bg-slate-50 rounded-[20px] py-7 px-5 flex gap-4">
      <div className="shrink-0">
        <img src={icon} alt="" />
      </div>
      <ul className="flex flex-col gap-7">
        {guidelines.map((guideline, index) => (
          <RefundGuideline key={index} {...guideline} />
        ))}
      </ul>
    </li>
  );
};

const RefundGuideline = ({ mainText, subText }) => {
  return (
    <li className="flex flex-col gap-2 font-medium leading-normal break-keep">
      <p>{mainText}</p>
      {subText && <p className="text-neutral-500">{subText}</p>}
    </li>
  );
};

const RefundPage = () => {
  const { brandId } = useSelectBrandId();
  const { color } = useSelectBrand();

  const refundGuidelines = brandId === "NB" ? nbRefundGuidelines : edRefundGuidelines;

  return (
    <section className="p-hasHeader">
      <Header title="교환/환불" />

      <h2 className="mt-10 flex items-center mb-5 gap-x-4 text-xl font-semibold font-['Pretendard'] leading-snug">
        <div className={`flex items-center justify-center w-16 h-16 bg-${color} rounded-[20px]`}>
          <img src={iconTit1} alt="" />
        </div>
        교환/환불 안내
      </h2>
      <ul className="flex flex-col gap-6">
        {refundGuidelines.map((guideline, index) => (
          <InfoCard key={index} {...guideline} />
        ))}
      </ul>

      <h2 className="mt-10  flex items-center mb-5 gap-x-4 text-xl font-semibold font-['Pretendard'] leading-snug">
        <div className={`flex items-center justify-center w-16 h-16 bg-${color} rounded-[20px]`}>
          <img src={iconTit2} alt="" />
        </div>
        별도의 교환/환불 기준 <br />
        적용 상품
      </h2>

      <h3 className="mb-5 font-medium ">
        가전상품 소비자 피해보상 규정에 준함
      </h3>

      <table className="w-full border border-neutral-200">
        <colgroup>
          <col className="w-4/12" />
          <col className="w-auto" />
        </colgroup>
        <tbody>
          <TableRow
            category="정상상품"
            items={[
              "박스 미개봉 시 1개월 이내 교환/환불 가능",
              "단, 박스 개봉 시 교환/환불 불가능",
            ]}
          />
          <TableRow
            category="불량상품"
            items={[
              "10일 이내 방문 시 환불 가능",
              "1달 이내 방문 시 상품 교환 또는 A/S 가능",
              "단, 불량상품 처리 시 반드시 영수증 지참",
            ]}
          />
        </tbody>
      </table>
    </section>
  );
};

export default RefundPage;
